<template>

    <div>

        <transition name="modal">
            <v-modal-segment-sync v-if="showModal === 'sync-' + segment.id" :segment="segment" @synced="$emit('synced')" />
            <v-modal-segment-export v-if="showModal === 'export-' + segment.id" :segment="segment" />
            <v-modal-segment-duplicate v-if="showModal === 'duplicate-' + segment.id" :segment="segment" @duplicated="$emit('duplicated')" />
            <v-modal-segment-delete v-if="showModal === 'delete-' + segment.id" :segment="segment" @deleted="$emit('deleted')" />
        </transition>

        <v-list-item class="segment">
            <div>
                <span><a href="#" @click.prevent="selectSegment">{{ segment.name }}</a></span><br>
                <span class="small">{{ segment.customers_count | numeral('0,0') }} {{ 'customer' | pluralize(segment.customers_count) }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <div class="meter">
                    <div class="meter-bar"><div v-if="perc > 0" :style="'width:' + (160 * perc) + 'px;'"></div></div>
                    <div class="meter-value">{{ perc * 100 | numeral('0.[0]') }}%</div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <span class="small text-muted mr-15">Created {{ segment.created_at | date }}</span>
                <v-button-toolbar size="sm">
                    <v-button size="sm" btn-style="secondary" @click.native="selectSegment">Edit</v-button>
                    <v-dropdown
                        type="secondary"
                        label="More"
                        :items="[
                            { key: 'sync', value: 'Sync Segment' },
                            { key: 'export', value: 'Export Segment' },
                            { key: 'duplicate', value: 'Duplicate Segment' },
                            { key: 'delete', value: 'Delete Segment' },
                        ]"
                        :show-selected="false"
                        :menu-right="true"
                        @change="onActionSelected">
                    </v-dropdown>
                </v-button-toolbar>
            </div>
        </v-list-item>

    </div>

</template>

<style scoped lang="scss">

    .meter {
        align-items: center;
        display: flex;
        .meter-value {
            @include font-medium(13px);
            color: $color-text;
            margin-left: 10px;
        }
        .meter-bar {
            background: $color-bg;
            border-radius: 3px;
            height: 6px;
            overflow: hidden;
            position: relative;
            width: 160px;
            > div {
                background: $color-primary;
                border-radius: 3px;
                height: 6px;
                left: 0;
                min-width: 6px;
                position: absolute;
                top: 0;
                z-index: 1;
            }
        }
    }

</style>

<script>

import ModalSegmentDelete from '@modals/segment/ModalSegmentDelete';
import ModalSegmentDuplicate from '@modals/segment/ModalSegmentDuplicate';
import ModalSegmentExport from '@modals/segment/ModalSegmentExport';
import ModalSegmentSync from '@modals/segment/ModalSegmentSync';

export default {

    components: {
        'v-modal-segment-delete': ModalSegmentDelete,
        'v-modal-segment-duplicate': ModalSegmentDuplicate,
        'v-modal-segment-export': ModalSegmentExport,
        'v-modal-segment-sync': ModalSegmentSync,
    },

    props: {
        segment: {
            type: Object,
            required: true,
        },
    },

    computed: {

        perc() {
            let total = this.$store.getters.project.customers_count;
            return this.segment.customers_count / total;
        },

    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'export') {
                this.$store.commit('showModal', 'export-' + this.segment.id);
            } else if (item.key === 'duplicate') {
                this.$store.commit('showModal', 'duplicate-' + this.segment.id);
            } else if (item.key === 'delete') {
                this.$store.commit('showModal', 'delete-' + this.segment.id);
            } else if (item.key === 'sync') {
                this.$store.commit('showModal', 'sync-' + this.segment.id);
            }
        },

        selectSegment() {
            this.$router.push({
                name: 'segments-edit',
                params: { id: this.segment.id },
            });
        },

    },

}

</script>